import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  // Same as native SearchModal — keeps a 128px gap from top and bottom
  paperFullWidth: { height: 'calc(100% - 128px)' },
  dialogTitle: {
    gap: theme.spacing(1),
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '1fr auto',
    '&> button': {
      marginTop: theme.spacing(1),
    },
  },
  input: { flex: 1 },
  button: {
    '&:hover': { background: 'none' },
  },
  dialogActionsContainer: { padding: theme.spacing(1, 3) },
  emptyStateWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  // Keeps the sidebar above the backdrop so hover-to-open still works
  backdrop: {},
}));
